import { render, staticRenderFns } from "./boothList.vue?vue&type=template&id=59b956e2&scoped=true"
import script from "./boothList.vue?vue&type=script&lang=js"
export * from "./boothList.vue?vue&type=script&lang=js"
import style0 from "./boothList.vue?vue&type=style&index=0&id=59b956e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b956e2",
  null
  
)

export default component.exports